import React, {Component} from 'react'
import LinkWithTooltip from '../../tooltip';

class TextArea extends Component {

  onChangeHandle(event){
    const { input: { value, onChange, name } } = this.props
    onChange(event.target.value);
  }

  render(){
    const { input, params } = this.props

    return(
      <div className="sp-pagebuilder-form-group" >
        <label>
          { params.title }
          {
            typeof params.desc != 'undefined' && params.desc != '' &&
            <LinkWithTooltip tooltip={params.desc} position="top" title={params.title}>
              <i className="fa fa-question-circle" />
            </LinkWithTooltip>
          }
        </label>
        <textarea {...input} className="sp-pagebuilder-form-control sp-pagebuilder-addon-input" onChange={ this.onChangeHandle.bind(this) } name={name}></textarea>
        
      </div>
    )
  }
}

export default TextArea;



// WEBPACK FOOTER //
// ./src/helpers/form/types/TextArea.js